export default __webpack_public_path__ + "static/Plots0011-a0c4cf20cde5f05b4b5803d32e3a05e4.jpg";